/**
 * Serviço de Email do Sistema MEDICARE
 * Gerencia operações relacionadas ao envio de emails
 */

import { ApiService } from './api';
import { ApiResponse } from '../types';

// Interface para dados de teste de email
export interface EmailTestData {
  destinatario: string;
  assunto: string;
  conteudo: string;
}

// Interface para resposta do teste de email
export interface EmailTestResponse {
  sucesso: boolean;
  mensagem: string;
  detalhes?: {
    destinatario: string;
    assunto: string;
    tempo_envio: number;
  };
}

export class EmailService {
  private static readonly BASE_URL = '/admin/email';

  /**
   * Testar envio de email
   */
  static async testarEnvio(dados: EmailTestData): Promise<ApiResponse<EmailTestResponse>> {
    return ApiService.post<EmailTestResponse>(`${this.BASE_URL}/teste`, dados);
  }
}

export default EmailService;